export enum HelpScoutUrls {
  consolidationGrowthCalculationMethodology = "https://manifest.helpscoutdocs.com/article/129-what-is-manifests-consolidation-growth-methodology",
  authorizationAgreement = "https://manifest.helpscoutdocs.com/article/95-authorization-agreement",
  howManifestPicksIraOptions = "https://manifest.helpscoutdocs.com/article/82-how-does-manifest-pick-ira-options",
  legal = "https://manifest.helpscoutdocs.com/category/127-legal-documents",
  termsOfService = "https://manifest.helpscoutdocs.com/article/87-terms-of-service",
  formADV = "https://manifest.helpscoutdocs.com/article/98-form-adv",
  formCRS = "https://manifest.helpscoutdocs.com/article/97-form-crs",
  privacyPolicy = "https://manifest.helpscoutdocs.com/article/88-privacy-policy",
  whatHappensAfterInitiateTransfer = "https://manifest.helpscoutdocs.com/article/99-what-happens-after-i-initiate-a-transfer-with-manifest",
  whereCanIFindMyAccountStatement = "https://manifest.helpscoutdocs.com/article/101-where-can-i-find-my-account-statement",
  userAgreement = "https://manifest.helpscoutdocs.com/article/93-customer-agreement",
  openLoanOptions = "https://manifest.helpscoutdocs.com/article/106-i-want-to-rollover-my-account-but-i-have-an-open-loan-what-are-my-options",
}

export enum EmployerHelpScoutUrls {
  userAgreement = "https://manifest.helpscoutdocs.com/article/130-user-agreement-employer",
  privacyPolicy = "https://manifest.helpscoutdocs.com/article/88-privacy-policy",
  termsOfService = "https://manifest.helpscoutdocs.com/article/87-terms-of-service",
}
